import Home from "@material-symbols/svg-500/rounded/home.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const HomeIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Home });
	return <Icon />;
};

export default memo(HomeIcon);
